import React from "react";
import WorkProcess from "../home/WorkProcess";
import OurOffering from "../home/OurOffering";
import Testimonial from "../home/Testimonial";
import HomeBlog from "../home/HomeBlog";

const HomeAbout = () => {
  return (
    <>
      <section
        className="banner__inner-page bg-image pt-180 pb-180 bg-image"
        style={{
          background: "url(/assets/images/banner/banner-inner-page.jpg)",
        }}
      >
        <div
          className="shape2 wow slideInLeft"
          data-wow-delay="00ms"
          data-wow-duration="1500ms"
        >
          <img src="/assets/images/banner/inner-banner-shape2.png" alt="shape" />
        </div>
        <div
          className="shape1 wow slideInLeft"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <img src="/assets/images/banner/inner-banner-shape1.png" alt="shape" />
        </div>
        <div
          className="shape3 wow slideInRight"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <img
            className="sway__animationX"
            src="/assets/images/banner/inner-banner-shape3.png"
            alt="shape"
          />
        </div>
        <div className="container">
          <h2
            className="wow fadeInUp"
            data-wow-delay="00ms"
            data-wow-duration="1500ms"
          >
            About Us
          </h2>
          <div
            className="breadcrumb-list wow fadeInUp"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <a href="index.html">Home</a>
            <span>
              <i className="fa-regular fa-angles-right mx-2" />
              About Us
            </span>
          </div>
        </div>
      </section>
      <section className="about-two-area pt-120">
        <div className="about-two__shape">
          <img src="/assets/images/shape/about-two-shape.png" alt="shape" />
        </div>
        <div className="container">
          <div className="row g-4">
            <div
              className="col-xl-6 wow fadeInRight"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="about-two__left-item">
                <div className="dots">
                  <img
                    className="sway_Y__animation"
                    src="/assets/images/shape/about-two-dot.png"
                    alt="shape"
                  />
                </div>
                <div className="shape-halper">
                  <img
                    className="sway__animation"
                    src="/assets/images/shape/about-circle-helper.png"
                    alt="shape"
                  />
                </div>
                <div className="image big-image">
                  <img
                    src="/assets/images/about/about-two-image1.jpg"
                    alt="image"
                  />
                </div>
                <div className="image sm-image">
                  <img
                    src="/assets/images/about/about-two-image2.png"
                    alt="image"
                  />
                </div>
                <div className="circle-shape">
                  <img
                    className="animation__rotate"
                    src="/assets/images/shape/about-two-circle.png"
                    alt="shape"
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="section-header mb-40">
                <h5
                  className="wow fadeInUp"
                  data-wow-delay="00ms"
                  data-wow-duration="1500ms"
                >
                  <img
                    className="me-1"
                    src="/assets/images/icon/section-title.png"
                    alt="icon"
                  />
                  WHO WE ARE
                </h5>
                <h2
                  className="wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  Ensuring Your Success Through Reliable IT Solutions{" "}
                </h2>
                <p
                  className="wow fadeInUp"
                  data-wow-delay="400ms"
                  data-wow-duration="1500ms"
                >
                  Aonsectetur adipiscing elit aenean scelerisque augue vitae
                  consequat aisque eget congue velit in cursus sodales the
                  turpis euismod quis sapien euismod quis sapien the condimentum
                  nec lorem nulla augue.
                </p>
              </div>
              <div
                className="about-two__right-item wow fadeInDown"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <ul>
                  <li>
                    <i className="fa-solid fa-check" />
                    Technology Consultancy
                  </li>
                  <li>
                    <i className="fa-solid fa-check" />
                    We Provide best services
                  </li>
                </ul>
                <ul>
                  <li>
                    <i className="fa-solid fa-check" />
                    Maintenance And Support
                  </li>
                  <li>
                    <i className="fa-solid fa-check" />
                    Requirements Gathering
                  </li>
                </ul>
              </div>
              <div
                className="about__info mt-50 wow fadeInDown"
                data-wow-delay="400ms"
                data-wow-duration="1500ms"
              >
                <a href="#0" className="btn-one">
                  Explore More <i className="fa-regular fa-arrow-right-long" />
                </a>
                <img src="assets/images/about/singature.png" alt="singature" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <WorkProcess />
      <OurOffering />
      <Testimonial />
      <HomeBlog /> */}
    </>
  );
};

export default HomeAbout;
